import type * as React from "react";
export type ShowProps<T> = {
  when: T;
  children: React.ReactNode | ((value: NonNullable<T>) => React.ReactNode);
  else?: React.ReactNode;
};

export function Show<T>(props: ShowProps<T>) {
  return props.when
    ? typeof props.children === "function"
      ? props.children(props.when as NonNullable<T>)
      : props.children
    : props.else ?? null;
}
